import { getAxiosInstance } from '../../react/utils/networkUtil';
import { PaginationQuery, PaginationResult } from '../models/AppPagination';
import { AppSuccess } from '../models/AppSuccess';
import { Element_Base, ElementType } from '../models/Element';
import { GeometryFormat } from '../models/GeometryFormat';
// #region get page
export interface Element_getPage_RequestQuery extends PaginationQuery, GeometryFormat {
  project_id?: number;
}
const remote_getPage = async (request: Element_getPage_RequestQuery): Promise<PaginationResult<Element_Base>> => {
  return (
    await getAxiosInstance().get('/api/element', {
      params: request,
    })
  ).data;
};
// #endregion

// #region get one
export const remote_getOne = async (uuid: string): Promise<Element_Base> => {
  return (await getAxiosInstance().get(`/api/element/${uuid}`)).data;
};
// #endregion

// #region create
export interface Element_create_Request {
  name?: string;
  description?: string;
  properties?: object;
  metadata?: object;

  project_id: number;
  type: ElementType;
  geojson: object; // geojson
}
export const remote_create = async (element: Element_create_Request): Promise<AppSuccess<Element_Base>> => {
  return (await getAxiosInstance().post('/api/element', element)).data;
};
// #endregion

// #region update
export interface Element_update_Request {
  name?: string;
  project_id?: number;
  type?: ElementType;

  description?: string;
  properties?: object; // json
  metadata?: object; // json
  geojson?: object; // geojson
}
export const remote_update = async (
  uuid: string,
  element: Element_update_Request,
): Promise<AppSuccess<Element_Base>> => {
  return (await getAxiosInstance().put(`/api/element/${uuid}`, element)).data;
};
// #endregion

// #region delete
export const remote_delete = async (uuid: string): Promise<AppSuccess<AppSuccess<Element_Base>>> => {
  return (await getAxiosInstance().delete(`/api/element/${uuid}`)).data;
};
// #endregion

export const ElementAPIs = {
  remote_getPage,
  remote_getOne,
  remote_create,
  remote_update,
  remote_delete,
};
